import React from "react";
import styles from "./button_plus_minus.module.css";


const ButtonPlusMinus = ({ state, setState }) => {

  return (
    <button className={`${state ? styles.button_p_m_open : styles.button_p_m}`}
      onClick={() => setState(!state)}
    >
      <span className={styles.button_p_m_horizontal} />
      <span className={styles.button_p_m_vertical} />
    </button>
  );
}

export default ButtonPlusMinus;
